import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
import { orgapi } from '../../ApiNames';


export const fetchNeedDataSuccess = (data: any) => ({
    type: 'FETCH_ORG_DATA_SUCCESS',
    payload: data,
});
export const fetchNeedDataViewSuccess = (dataview: any) => ({
    type: 'FETCH_ORG_VIEW_DATA_SUCCESS',
    payload: dataview,
});
export const fetchNeedAttachDataSuccess = (attachdataview: any) => ({
    type: 'FETCH_ORG_ATTAC_VIEW_DATA_SUCCESS',
    payload: attachdataview,
});
export const fetchNeedDataattachViewSuccess = (attachdata: any) => ({
    type: 'FETCH_ORG_VIEW_ATTACH_DATA_SUCCESS',
    payload: attachdata,
});

export const fetchData = (Id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {"need":Id};
            const apiname = orgapi.orgneedprofile;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchNeedDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const viewdata = (Id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {"need":Id};
            const apiname = orgapi.orgneedtable;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchNeedDataViewSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};


export const viewattachmentdata = (Id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {"need":Id,q:3};
            const apiname = orgapi.orgneedprofile;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchNeedAttachDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const viewdataattach = (uid:any,Id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { userid:uid,needid:Id};
            const apiname = orgapi.orgneedview;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchNeedDataattachViewSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};